import LazyLoad from 'vanilla-lazyload';

new LazyLoad({
	elements_selector: '.js-lazy',
});
